import { Helmet } from "react-helmet-async";
import { Layout } from "../../components/layout";
import {
  CustomModal,
  Dropdown,
  Input,
  LoadingSpinner,
  MyButton,
  Pagination,
  EmptyTable,
} from "../../components";
import { BsList, BsThreeDotsVertical } from "react-icons/bs";
import {
  Menu,
  MenuItem,
  Button,
  Select,
  IconButton,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { LeadsController } from "../../controllers";
import { Cancel } from "../../../assets";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa";
class Leads extends LeadsController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getLeadsList();
  }
  render() {
    const {
      openSendTicketModal,
      ticketCount,
      rowsCountList,
      membersList,
      errorsList,
      leadsList,
      loading,
      member,
      count,
      page,
    } = this.state;
    return (
      <>
        <Layout title="بانک اطلاعاتی">
          <Helmet>
            <title> بانک اطلاعاتی | سامانه مشتریان</title>
          </Helmet>
          <div className="users-list">
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <>
                  <div className="users-list-headline mt-3">
                    <div className="">
                      <BsList color="#003366" className="ms-2" />{" "}
                      <span className="title">بانک اطلاعاتی</span>
                    </div>
                  </div>
                  <div className="users-list-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>ردیف</TableCell>
                          <TableCell>موضوع </TableCell>
                          <TableCell>سرنخ‌های آزاد</TableCell>
                          <TableCell>عملیات</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!leadsList?.list?.length && <EmptyTable />}
                        {leadsList?.list?.map((item: any, index: number) => {
                          return (
                            <>
                              <TableRow
                                key={index}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {index + 1}
                                </TableCell>
                                <TableCell>{item?.subject || "--"}</TableCell>
                                <TableCell>{item?.free_lead_total}</TableCell>
                                <TableCell>
                                  <PopupState
                                    variant="popover"
                                    popupId="demo-popup-menu"
                                  >
                                    {(popupState: any) => (
                                      <>
                                      <IconButton
                                          sx={{
                                            color: "#0c1a58",
                                            padding: "4px"
                                          }}
                                          {...bindTrigger(popupState)}
                                        >
                                          <BsThreeDotsVertical />
                                        </IconButton>
                                        {/* <Button
                                          sx={{
                                            background: "#D4AF37",
                                            ":hover": {
                                              bgcolor: "#D4AF37",
                                            },
                                          }}
                                          variant="contained"
                                          {...bindTrigger(popupState)}
                                        >
                                          عملیات
                                        </Button> */}
                                        <Menu {...bindMenu(popupState)}>
                                          <MenuItem
                                            onClick={() =>
                                              this.handleSendTicketModal(item)
                                            }
                                          >
                                            ارسال تیکت
                                          </MenuItem>
                                          <Link to={`/lead/${item?.id}`}>
                                            <MenuItem>لیست سرنخ‌ها</MenuItem>
                                          </Link>
                                        </Menu>
                                      </>
                                    )}
                                  </PopupState>
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                    <Pagination
                      count={leadsList?.pages ? leadsList?.pages : 1}
                      page={page}
                      total={leadsList?.total}
                      pageNumber={leadsList?.page_number}
                      onChangePage={this.handleChangePage}
                      rowsCountList={rowsCountList}
                      countValue={count}
                      onChangeCount={(value: any) => this.handleCount(value)}
                    />
                  </div>
                </>
                <CustomModal
                  myStyle="one-field-modal"
                  openModal={openSendTicketModal}
                  onClose={() =>
                    this.setState({
                      openSendTicketModal: !openSendTicketModal,
                      selectedLead: {},
                      member: null,
                      ticketCount: "",
                      errorsList: [],
                    })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">ارسال تیکت</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() =>
                          this.setState({
                            openSendTicketModal: !openSendTicketModal,
                            selectedLead: {},
                            member: null,
                            ticketCount: "",
                            errorsList: [],
                          })
                        }
                      />
                    </div>

                    <div className="custom-modal-content">
                    <div className="custom-modal-row">
                      <Input
                        error={
                          errorsList.filter(
                            (name: { path: string }) =>
                              name.path === "ticketCount"
                          )?.[0]?.errors?.[0]
                        }
                        type="number"
                        myStyle=" w-100"
                        title="تعداد  "
                        value={ticketCount}
                        onChange={(e: any) =>
                          this.setState({ ticketCount: e.target.value })
                        }
                        emptyState={() => this.setState({ ticketCount: "" })}
                      />
                    </div>
                    <div className="custom-modal-row mb-57">
                      <Dropdown
                        placeholder="یک گزینه را انتخاب کنید"
                        items={membersList}
                        objectList
                        myStyle=" w-100"
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "member"
                          )?.[0]?.errors?.[0]
                        }
                        title="اعضا"
                        value={member}
                        onChange={this.handleChangeMember}
                        emptyState={() => this.setState({ member: "" })}
                      >
                        {membersList &&
                          membersList?.map((item: any, index: number) => {
                            return (
                              <MenuItem value={item?.id} key={index}>
                                {item?.title}
                              </MenuItem>
                            );
                          })}
                      </Dropdown>
                    </div>
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        loading={this.state.isSendingTicket}
                        onClick={() => this.handleSendLeadTicket()}
                      />
                    </div>
                  </div>
                  </>
                </CustomModal>
              </>
            )}
          </div>
        </Layout>
      </>
    );
  }
}
export default Leads;
